import axios from 'axios';

import { headers, ledgerServiceUrl as LEDGER_URL } from '../../config';

export function getTrialBalance(query, customHeaders) {
    return axios.get(`${LEDGER_URL}/trial-balance`, { headers: {...headers(), ...customHeaders}, params: query })
}

export function getDimensionsReport(query) {
    return axios.get(`${LEDGER_URL}/dimension-report`, { headers: headers(), params: query })
}

export function getAccountStatement({account_id, from, to}, customHeaders) {
    return axios.get(`${LEDGER_URL}/statements`, { headers: {...headers(), ...customHeaders}, params: {account_id, from, to} })
}